import React from "react";
import mint from "./Logo-mint-mobile.png";
import ultra from "./Logo-ultra-mobile.png";

const logos = { mint, ultra };
const alt = { mint: 'Mint Mobile', ultra: 'Ultra Mobile' }
export default function Logo({ brandName }) {
  return <img alt={alt[brandName]} style={{ float: "right" }} src={logos[brandName]} />;
}
